export enum AppearanceDataType {
  Draw,
  Type,
  Image,
}

export enum AppearanceType {
  Signature,
  Initial,
}
